function IconVip({ className }: { className?: string }) {
  return (
    <svg fill="none" width="16" height="16" className={className}>
      <path d="M2.5 14V2h3v7.5l5-7.5h3l-8 12h-3Z" fill="#FFB211" />
    </svg>
  );
}

export default IconVip;
